// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__MTBtZ","Success":"Button_Success__9CMXt","Danger":"Button_Danger__1n63L"};